import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import i18next from 'i18next';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-order-modal',
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.scss'],
  imports: [CommonModule, I18NextModule]
})
export class OrderModalComponent implements OnInit {
  @Input() modalData = false;
  @Output() closeModalEmitter = new EventEmitter<void>();
  @Output() spinnerModalEmitter = new EventEmitter<boolean>(false);

  modalText = '';

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.openModal();
  }

  openModal() {
    this.modalData === true
      ? (this.modalText = i18next.t('orderSuccess'))
      : (this.modalText = i18next.t('orderFailed'));
  }

  closeModal() {
    this.activeModal.close();
    if (this.modalData === false) {
      this.router.navigateByUrl('/landing');
    } else {
      this.closeModalEmitter.emit();
      this.spinnerModalEmitter.emit(true);
    }
  }
}
